import React from 'react';

/**
 * Inline promo card that redirects to klone.thelokal.ca in a new tab.
 * Variants:
 *   - "banner"  → wide, standalone hero-style card (landing page)
 *   - "inline"  → compact card that slots into the form Step 2
 *   - "chip"    → tiny pill-shaped link (near CTAs / footers)
 */
const KLONE_URL = 'https://klone.thelokal.ca';

const KloneDiscoverCTA = ({ variant = 'banner', testId = 'ff-klone-cta' }) => {
  const openKlone = () => {
    window.open(KLONE_URL, '_blank', 'noopener,noreferrer');
  };

  if (variant === 'chip') {
    return (
      <button
        type="button"
        data-testid={testId}
        onClick={openKlone}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 8,
          padding: '8px 16px',
          borderRadius: 999,
          background: 'rgba(201,169,97,0.15)',
          color: 'var(--ff-burgundy)',
          border: '1px solid var(--ff-gold)',
          fontSize: 14,
          fontWeight: 600,
          cursor: 'pointer',
          textDecoration: 'none',
        }}
      >
        <span aria-hidden="true">🍷</span>
        Not sure? Discover your wine →
      </button>
    );
  }

  if (variant === 'inline') {
    return (
      <div
        data-testid={testId}
        style={{
          margin: '18px 0',
          padding: 18,
          borderRadius: 10,
          background: 'linear-gradient(135deg, rgba(114,47,55,0.06), rgba(201,169,97,0.12))',
          border: '1px dashed var(--ff-gold)',
          display: 'flex',
          flexWrap: 'wrap',
          gap: 12,
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <div style={{ flex: '1 1 240px' }}>
          <p style={{
            margin: 0,
            fontSize: 12,
            letterSpacing: 1.5,
            textTransform: 'uppercase',
            color: 'var(--ff-gold)',
            fontWeight: 700,
          }}>
            Wine matchmaker
          </p>
          <p style={{ margin: '4px 0 0', fontFamily: 'Playfair Display, serif', fontSize: 18, color: 'var(--ff-burgundy)' }}>
            Not sure which wine to pick?
          </p>
          <p style={{ margin: '2px 0 0', fontSize: 13, color: 'var(--ff-brown-soft)' }}>
            With over 150 wines available, we'll help you uncover the perfect wine based entirely on your tastes. Takes less than 3 minutes.
          </p>
        </div>
        <button
          type="button"
          onClick={openKlone}
          className="ff-btn ff-btn-primary"
          style={{ minHeight: 44, padding: '10px 20px', fontSize: 15 }}
        >
          Discover Your Wine ↗
        </button>
      </div>
    );
  }

  // banner (default)
  return (
    <section
      data-testid={testId}
      className="ff-card"
      style={{
        padding: '32px 28px',
        display: 'flex',
        gap: 20,
        alignItems: 'center',
        flexWrap: 'wrap',
        background: 'linear-gradient(135deg, var(--ff-burgundy), var(--ff-brown))',
        color: 'var(--ff-cream)',
        border: '1px solid rgba(201,169,97,0.35)',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <div
        aria-hidden="true"
        style={{
          position: 'absolute',
          right: -40,
          top: -60,
          width: 200,
          height: 200,
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(201,169,97,0.35), transparent 70%)',
          pointerEvents: 'none',
        }}
      />
      <div style={{ flex: '1 1 340px', position: 'relative' }}>
        <p style={{
          margin: 0,
          fontSize: 12,
          letterSpacing: 2,
          textTransform: 'uppercase',
          color: 'var(--ff-gold-soft)',
          fontWeight: 700,
        }}>
          Powered by Klone Cellar
        </p>
        <h3 style={{
          margin: '6px 0 8px',
          color: 'var(--ff-cream)',
          fontSize: 26,
        }}>
          Not sure? Discover Your Wine.
        </h3>
        <p style={{ margin: 0, opacity: 0.85, fontSize: 15 }}>
          With over 150 wines available, we'll help you uncover the perfect
          wine based entirely on your tastes. Takes less than 3 minutes.
        </p>
      </div>
      <button
        type="button"
        onClick={openKlone}
        className="ff-btn ff-btn-gold"
        style={{ minHeight: 52, position: 'relative' }}
      >
        Open Klone Cellar ↗
      </button>
    </section>
  );
};

export default KloneDiscoverCTA;
